import { Component, OnInit, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GfTitleService } from '../../../../services/core.title.service';
import * as _ from 'lodash';
import { UiService } from '../../../../services/core.ui.service';
import { ProjectService } from '../../../../services/project.service';
import { TrackerFilterService } from '../../../../../plugins/tracker/services/tracker.filter.service';
import { StateService } from '@uirouter/angular';
import { ProjectAdminGroupAddComponent } from './projectAdminGroupAdd/project.admin.groups.add.component';
import { ProjectAdminGroupEditComponent } from './projectAdminGroupEdit/project.admin.group.edit.component';
import { ProjectAdminGroupDeleteComponent } from './projectAdminGroupDelete/project.admin.group.delete.component';

@Component({
  selector: 'project-admin-groups',
  template: require('./project.admin.groups.html')
})
export class ProjectAdminGroupsComponent implements OnInit {
  active = '';
  loading = false;
  @Input() project: any;
  @Input() isProjectAdmin: any;
  @Input() groups: any;

  statuses: { [key: string]: string };
  sortFields: any;
  page_size: number;
  page_num: number;
  sort_dir: string;
  sort_field: string;
  groupUnixName: string;
  name: string;
  newGroup: any;
  addUser: any;
  baseFilters: any;
  filters: any;

  constructor(
    private stateService: StateService, 
    
    private uiService: UiService,
    private projectService: ProjectService,
    private trackerFilterService: TrackerFilterService,
    private modalService: NgbModal,
    private titleService: GfTitleService
  ) {
    this.statuses = {
      '-1': 'Pending approval',
      '0': 'Pending',
      '1': 'Active',
      '2': 'Deleted',
      '3': 'Suspended'
    };
    this.sortFields = { unixName: 'Unix Name', name: 'Group Name', id: 'Creation Date' };

    const queryParams = this.stateService.params;
    this.page_size = _.get(queryParams, 'page_size', 20);
    this.page_num = _.get(queryParams, 'page_num', 1);
    this.sort_dir = _.get(queryParams, 'sort_dir', 'asc');
    this.sort_field = _.get(queryParams, 'sort_field', 'id');
    this.groupUnixName = queryParams?.groupUnixName ?? null;
    this.name = queryParams?.name ?? null;
    this.newGroup = {};
    this.addUser = {
      searchItemsResult: [],
      autoSubmitTimer: null,
      searching: false,
      search: ''
    };

    // Assuming gettextCatalog is globally available or injected; adjust as needed.
    const gettextCatalog = { getString: (str: string) => str };

    this.baseFilters = {
      main_fields: [
        {
          alias: "name",
          fieldName: gettextCatalog.getString("Group name"),
          value: this.name == null ? '' : this.name,
          fieldType: 4,
          isExtraField: false
        },
        {
          alias: "groupUnixName",
          fieldName: gettextCatalog.getString("Unix name"),
          value: this.groupUnixName == null ? '' : this.groupUnixName,
          fieldType: 4,
          isExtraField: false
        }
      ]
    };
  }

  ngOnInit(): void {
    this.titleService.setTitle(this.project.name, 'Admin', 'Groups');
    this.groups = this.groups.items;
    this.filters = _.cloneDeep(this.baseFilters);
  }

  onSort(params: any = {}): void {
    this.sort_field = params.key;
    this.sort_dir = params.sortDir;
    const _params: any = {
      sort_dir: params.sortDir,
      sort_field: params.key
    };
    if (this.filters.main_fields[0].value != null) {
      _params.name = this.filters.main_fields[0].value;
    }
    if (this.filters.main_fields[1].value != null) {
      _params.groupUnixName = this.filters.main_fields[1].value;
    }
    this.stateService.go('.', _params);
  }

  resetFilters(): void {
    this.filters = _.cloneDeep(this.baseFilters);
    const params = { ...this.stateService.params };
    params.sort_dir = 'asc';
    params.sort_field = 'id';

    if (!params.name || params.name === '') {
      delete params.name;
    }
    if (!params.groupUnixName || params.groupUnixName === '') {
      delete params.groupUnixName;
    }

    const queryParams = this.stateService.params;
    this.groupUnixName = queryParams?.groupUnixName ?? null;

    this.filters.main_fields[0].value = '';
    this.filters.main_fields[1].value = '';

    this.sort_dir = _.get(queryParams, 'sort_dir', 'asc');
    this.sort_field = _.get(queryParams, 'sort_field', 'id');

    params.name = '';
    params.page_num = this.page_num;
    params.page_size = this.page_size;
    params.sort_dir = this.sort_dir;
    params.sort_field = this.sort_field;

    this.stateService.go('.', params, { reload: false, notify: true, location: 'replace', inherit: true }).then(() => {
      this.applyFilters();
    });
    
  }

  applyFilters(): void {
    let _params = this.trackerFilterService.applyFilters(this.filters, 0);
    delete _params.tracker;
    delete _params.forceReload;

    this.stateService.go('.', _params, { location: 'replace', notify: false })
    .then(() => {
      this.projectService.getGroups(this.project.unixName, _params).then(
        (response: any) => {
          this.groups = response.items;
        },
        () => {
          this.groups = [];
          this.uiService.message.showError('There was an error performing the query', 'Group query error');
        }
      );
    });
  }

  groupAddCallback(): void {
    this.applyFilters();
  }

  showGroupAdd($event: Event): void {
    $event.preventDefault();
    $event.stopPropagation();

    const modalRef = this.modalService.open(ProjectAdminGroupAddComponent);
    modalRef.componentInstance.project = this.project;
    modalRef.componentInstance.onAdd.subscribe(() => {
        this.groupAddCallback();
        modalRef.close();
    });
    modalRef.componentInstance.onClose.subscribe(() => {
        modalRef.close();
    });
  }

  showGroupEdit(group: any, $event: Event): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.projectService.getGroup(this.project.unixName, group.id).then(
      (response: any) => {
        const modalRef = this.modalService.open(ProjectAdminGroupEditComponent);
        modalRef.componentInstance.project = this.project;
        modalRef.componentInstance.group = response;
        modalRef.componentInstance.onEdit.subscribe(() => {
            this.applyFilters();
            modalRef.close();
        });
        modalRef.componentInstance.onClose.subscribe(() => {
            modalRef.close();
        });
      },
      () => {
        this.uiService.message.showError('There was an error fetching the group', 'Edit group');
      }
    );
  }

  goupDeleteCallback(): void {
    this.applyFilters();
  }

  showGroupDelete(group: any, $event: Event): void {
    $event.preventDefault();
    $event.stopPropagation();

    const modalRef = this.modalService.open(ProjectAdminGroupDeleteComponent);
    modalRef.componentInstance.project = this.project;
    modalRef.componentInstance.group = group;
    modalRef.componentInstance.onDelete.subscribe(() => {
        this.goupDeleteCallback();
        modalRef.close();
    });
    modalRef.componentInstance.onClose.subscribe(() => {
        modalRef.close();
    });
  }

  trackById(index: number, item: any): any {
    return item.id;
  }
}
